//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
  IconColors,
} from '@hub/design-system-base'
import { default as ArrowLeftMediumSVG } from './assets/medium/arrow-left.inline.svg'

interface ArrowLeftMediumIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
  ariaLabel?: string
  color?: IconColors
}

export const ArrowLeftMediumIcon: React.FC<
  React.PropsWithChildren<ArrowLeftMediumIconProps>
> = forwardRef<ArrowLeftMediumIconProps, typeof ChakraIcon>(
  ({ boxSize = 'size-icon-sm', sx, ariaLabel, color }, ref) => (
    <ChakraIcon
      ref={ref}
      boxSize={boxSize}
      aria-label={ariaLabel}
      as={ArrowLeftMediumSVG}
      sx={sx}
      color={color}
    />
  )
)
